/**
 * Created by ostapenko.r on 2/9/2015.
 */
angular.module('flipto.components.common.validation', ['flipto.core.lodash']);